import React from "react";
import { useNotify, useRefresh } from "react-admin";
import { Button } from "@mui/material";
import FormModal from "server/components/Modals/FormModal";
import EditIcon from "@mui/icons-material/Edit";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import dataProvider from "server/dataProvider";
import { specialistRequests } from "api/specialistApi";

const UpdateAccreditationExpiryDateDialog = ({ buildingId, specializationId }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async data => {
    if (!buildingId || !specializationId) return;
    const payload = {
      accreditationExpiryDate: data.accreditationExpiryDate,
    };

    await dataProvider.customRequest(
      specialistRequests.updateTrainingBuildingAccreditationExpireDate(buildingId, specializationId),
      payload,
      "PUT",
    );
    refresh();
    notify("Успешна промяна на валидност на акредитация на сградата", { type: "success" });
  };
  return (
    <FormModal
      titleContent={"Промени валидност на акредитация на сградата"}
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          variant="contained"
          size="small"
          startIcon={<EditIcon />}
        >
          Валидност
        </Button>
      }
    >
      <CustomDateInput
        source="accreditationExpiryDate"
        label="Валидност на акредитация"
        noTime
      />
    </FormModal>
  );
};

export default UpdateAccreditationExpiryDateDialog;
